import React from "react";
import { Navigate, Route, Routes } from "react-router";
import List from "./List";
import View from "./View";

const AdsModule: React.FC = () => {
    return (
        <Routes>
            <Route index element={<List />} />
            <Route path="/*" element={<Navigate to="" />} />
            <Route path="/:id" element={<View />} />
        </Routes>
    );
};

export default AdsModule;
